module.exports = __webpack_public_path__ + "static/media/Insta.04f1d872.svg";